import { CORE_ACTIVITY_CODE } from './presetSideEffects';

// Shared Funding-filter rules. Both the main search sidebar and the org profile
// filter panel render their own Funding section against their own redux slice,
// so the rules that tie those fields together live here rather than in either
// component.

// Core Labs Only tracks the P30 activity code: selecting it implies the flag,
// clearing it drops the flag again.
export const coreFlagForActivityCode = value =>
  Array.isArray(value) && value.includes(CORE_ACTIVITY_CODE);

// Funding Expiring Within 3 Months and Early Budget cannot both be applied, so
// whichever is ticked locks the other out until it is cleared. `locked` is kept
// separate from `disabled` because a locked field swaps its tooltip for the
// incompatible-filter message, while one disabled by `loading` keeps its own.
export const getFundingCheckboxStates = ({
  loading,
  grantExpiry,
  earlyAwardDate,
  fundingStarts,
} = {}) => {
  const grantExpiryLocked = !!earlyAwardDate && !grantExpiry;
  const earlyAwardDateLocked = !!grantExpiry && !earlyAwardDate;

  return {
    grantExpiryLocked,
    earlyAwardDateLocked,
    grantExpiryDisabled: !!loading || grantExpiryLocked,
    earlyAwardDateDisabled:
      !!loading || !!fundingStarts || earlyAwardDateLocked,
  };
};
